// --progress-bar-transition-speed is defined on the Host in the .tsx
$border: 1px solid var(--color-border-surface-on-elevation-1);

:host {
  --top-bar-progress: 0%;
  display: grid;
  grid-template-rows: 0fr;
  transition: var(--timing-fast) grid-template-rows;
  overflow: hidden;

  //icon
  --ds-icon-size-box--small: var(--font-size-body-s);
  --ds-icon-size--small: 100%;

  > * {
    overflow: hidden;
  }
}
:host(.disable-transition) {
  --progress-bar-transition-speed: 0 !important;
}
:host(.visible) {
  grid-template-rows: 1fr;
}
.top-state-bar {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-gap-l);

  > * {
    position: relative;
    z-index: 1;
  }
  border-radius: 4px;
  list-style: var(--font-size-body-s);
  display: flex;

  &__outer-wrapper {
    &::after,
    &::before {
      border-radius: 4px;
    }
    &::before {
      content: "";
      inline-size: 100%;
      block-size: 100%;
      inset-inline-start: 0;
      inset-block-start: 0;
      position: absolute;
      background-color: var(--color-accent-surface-elevation-3);
      z-index: 0;
    }
    &::after {
      content: "";
      inset-inline-start: 1px;
      inset-block-start: 1px;
      inline-size: calc(100% - 1px * 2);
      block-size: calc(100% - 1px * 2);
      position: absolute;
      background-color: var(--color-accent-surface-surface);
      z-index: 1;
    }

    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-gap-l);
    padding: var(--spacing-padding-l) var(--spacing-padding-l);
  }
  &__inner-wrapper {
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: var(--spacing-gap-m);
    position: relative;
    z-index: 2;
  }
  &__caption {
    color: var(--color-text-neutral-strawberry);
    font-size: var(--font-size-body-s);
    line-height: var(--font-size-body-s);
    font-weight: var(--font-style-regular);
    display: flex;
    align-items: center;
    font-style: italic;
  }
  &__progress-wrapper {
    block-size: 4px;
    background-color: var(--color-accent-surface-elevation-1);
    position: relative;
    z-index: 2;
  }
  &__close {
    cursor: pointer;
    transition: var(--timing-fast) background-color;
  }
  &__inner-wrapper,
  &__progress-wrapper,
  &__close {
    opacity: 0;
    transition: 150ms opacity;
  }

  /*states*/
  &--accent {
    .progress-bar {
      background-color: var(--color-accent-primary-default);
    }
  }
  &--success {
    .progress-bar {
      background-color: var(--color-border-success-default);
    }
  }
  &--warning {
    .progress-bar {
      background-color: var(--color-border-warning-default);
    }
  }
  &--error {
    .progress-bar {
      background-color: var(--color-border-error-default);
    }
  }
  &--in-progress {
    .top-state-bar__outer-wrapper:before {
      block-size: 0;
      inline-size: 120%;
      padding-block-start: 60%;
      padding-block-end: 60%;
      background: linear-gradient(
        90deg,
        rgba(91, 167, 255, 0.4) 0%,
        rgba(63, 168, 155, 0.4) 100%
      );
      inset-block-start: 50%;
      inset-inline-start: 50%;
      transform: translate(-50%, -50%);
      -webkit-animation: inProgressBackgroundColor 1s linear infinite;
      animation: inProgressBackgroundColor 1s linear infinite;
    }
    .progress-bar {
      position: relative;
      overflow: hidden;
      z-index: 1;
      &:after {
        content: "";
        position: absolute;
        z-index: 0;
        inline-size: 300%;
        block-size: 100%;
        inset-inline-start: 0;
        background: linear-gradient(
          90deg,
          rgba(147, 245, 235, 1) 0%,
          rgba(26, 163, 255, 1) 33%,
          rgba(147, 245, 235, 1) 66%,
          rgba(26, 163, 255, 1) 100%
        );
        animation-name: inProgressBar;
        animation-duration: 2s;
        animation-iteration-count: infinite;
      }
    }
  }
  &--visible {
    .top-state-bar__inner-wrapper,
    .top-state-bar__progress-wrapper,
    .top-state-bar__close {
      opacity: 1;
    }
    .top-state-bar__close {
      &:hover {
        opacity: 0.75;
      }
      &:active {
        opacity: 0.5;
      }
    }
  }
}

// With Close Button (some spacing needs to be adjusted)
:host(.with-close-button) {
  .top-state-bar {
    &__outer-wrapper {
      padding-block-start: 4px;
      gap: var(--spacing-gap-xs);
    }
  }
}

/*in progress animation*/
@-webkit-keyframes inProgressBackgroundColor {
  0% {
    transform: translate(-50%, -50%) rotate(0);
  }
  100% {
    transform: translate(-50%, -50%) rotate(1turn);
  }
}
@-webkit-keyframes inProgressBar {
  0% {
    inset-inline-start: 0%;
  }
  100% {
    inset-inline-start: -200%;
  }
}
@-moz-keyframes inProgressBar {
  0% {
    inset-inline-start: 0%;
  }
  100% {
    inset-inline-start: 200%;
  }
}
@keyframes inProgressBar {
  0% {
    inset-inline-start: 0%;
  }
  100% {
    inset-inline-start: -200%;
  }
}

.progress-bar {
  display: block;
  transition: all var(--progress-bar-transition-speed);
  inline-size: var(--top-bar-progress);
  border-radius: calc(4px / 2);
  block-size: 100%;
}

:host(.no-border),
:host(.border-block-start),
:host(.border-block-end) {
  .top-state-bar__outer-wrapper {
    &:before {
      display: none;
    }
  }
}
:host(.border-block-start) {
  .top-state-bar__outer-wrapper {
    border-block-start: $border;
  }
}
:host(.border-block-end) {
  .top-state-bar__outer-wrapper {
    border-block-end: $border;
  }
}
